import { api } from './client';
import type { WebUser, Role, PaginatedResponse } from './types';

export interface WebUserCreatePayload {
  name: string;
  email: string;
  password: string;
  role: Role;
  is_active?: boolean;
}

export interface WebUserUpdatePayload {
  name?: string;
  email?: string;
  role?: Role;
  is_active?: boolean;
}

export async function listWebUsers(params?: {
  page?: number;
  role?: Role;
  q?: string;
}): Promise<PaginatedResponse<WebUser>> {
  const { data } = await api.get<PaginatedResponse<WebUser>>('/web-users', { params });
  return data;
}

export async function getWebUser(id: number): Promise<WebUser> {
  const { data } = await api.get<{ data: WebUser }>(`/web-users/${id}`);
  return data.data;
}

export async function createWebUser(payload: WebUserCreatePayload): Promise<WebUser> {
  const { data } = await api.post<{ data: WebUser }>('/web-users', payload);
  return data.data;
}

export async function updateWebUser(
  id: number,
  payload: WebUserUpdatePayload,
): Promise<WebUser> {
  const { data } = await api.put<{ data: WebUser }>(`/web-users/${id}`, payload);
  return data.data;
}

export async function deleteWebUser(id: number): Promise<void> {
  await api.delete(`/web-users/${id}`);
}

export async function resetWebUserPassword(id: number, password: string): Promise<void> {
  await api.post(`/web-users/${id}/reset-password`, { password });
}

export async function listAdmins(): Promise<WebUser[]> {
  const { data } = await api.get<{ data: WebUser[] } | WebUser[]>('/web-users-admins');
  // Unwrap Laravel Resource collection if wrapped in {data}, else return as-is
  if (Array.isArray(data)) return data;
  return data.data;
}

export async function changeMyPassword(payload: {
  current_password: string;
  new_password: string;
  new_password_confirmation: string;
}): Promise<void> {
  await api.post('/auth/change-password', payload);
}
